import React from 'react';
import { addHours } from 'date-fns';
import { twMerge } from 'tailwind-merge';
import { DateTimeTooltip } from '@components/main-components/datetime-tooltip';
import { useTimer } from '@hooks/useTimer';
import { getActivityTimestamp } from '@utils/helpers';

function TimestampText({
  timestampDate,
  className,
  addSuffix,
}: {
  timestampDate: Date;
  className?: string;
  addSuffix?: boolean;
}) {
  const expiryTimestamp = React.useMemo(() => {
    return addHours(timestampDate, 1);
  }, [timestampDate]);

  const { seconds } = useTimer({
    expiryTimestamp,
  });
  const everyFiveSeconds = seconds % 5 === 0;

  const activityTimestamp = React.useMemo(
    () => getActivityTimestamp(timestampDate.getTime(), addSuffix),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addSuffix, timestampDate, everyFiveSeconds],
  );

  return (
    <span
      className={twMerge(
        'whitespace-nowrap font-base text-base-xs tabular-nums text-base400',
        className,
      )}
    >
      {activityTimestamp}
    </span>
  );
}

export const Timestamp = ({
  timeStamp,
  className,
  addSuffix,
}: {
  timeStamp: number | string;
  className?: string;
  addSuffix?: boolean;
}) => {
  const timestampDate = React.useMemo(() => new Date(timeStamp), [timeStamp]);

  const text = React.useMemo(
    () => (
      <TimestampText timestampDate={timestampDate} className={className} addSuffix={addSuffix} />
    ),
    [addSuffix, className, timestampDate],
  );

  return (
    <>
      <div className="flex items-center lt:hidden">{text}</div>
      <DateTimeTooltip dateTime={timestampDate} className="hidden items-center lt:flex">
        {text}
      </DateTimeTooltip>
    </>
  );
};
